<div class="help-center-wrapper" (click)="openHelpCenter()">
	<P>?</P>
</div>
